import { ChangeEvent, ReactElement, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { Appearance, Design } from '@Components/designConstants';

interface SavePlanModalProps {
  onCancel: () => void;
  onSave: (name: string) => void;
  entityLabel?: string;
}

export const SavePlanModal = ({
  onCancel,
  onSave,
  entityLabel = 'Plan'
}: SavePlanModalProps): ReactElement => {
  const [name, setName] = useState('');
  const trimmed = name.trim();
  const disabled = trimmed.length === 0;

  return (
    <Modal show centered size='lg' onHide={onCancel}>
      <Modal.Header>
        <Modal.Title>Save New {entityLabel}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>{entityLabel} Name</Form.Label>
        <Form.Control
          autoFocus
          value={name}
          placeholder={`Enter a name for this ${entityLabel.toLowerCase()}`}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={disabled} onClick={() => onSave(trimmed)}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
